/// <reference lib="dom" />
import { User } from 'oidc-client-ts';
import { getTerraConfigValue } from './config-provider';

/**
 * Build Authorization header for OpenID-only UI requests.
 * Returns undefined when not using OpenID or no token is available,
 * so the client skips setting the header (allowing cookie-based auth to work).
 */
export function getAuthorizationHeader(): string | undefined {
  if (getTerraConfigValue('NEXT_PUBLIC_AUTH_PROVIDER') !== 'openid') {
    return undefined;
  }

  if (
    typeof window === 'undefined' ||
    typeof localStorage === 'undefined' ||
    typeof sessionStorage === 'undefined'
  ) {
    return undefined;
  }

  const cognitoDomain =
    getTerraConfigValue('NEXT_PUBLIC_OIDC_COGNITO_DOMAIN') || '';
  const issuerUrl = getTerraConfigValue('NEXT_PUBLIC_OIDC_ISSUER_URL') || '';
  const authority = cognitoDomain || issuerUrl;
  const clientId = getTerraConfigValue('NEXT_PUBLIC_OIDC_CLIENT_ID');

  if (!authority || !clientId) {
    return undefined;
  }

  const key = `oidc.user:${authority}:${clientId}`;
  const oidcStorage = localStorage.getItem(key);

  if (!oidcStorage) {
    const electronToken = sessionStorage.getItem('terra.electron.access_token');
    return electronToken ? `Bearer ${electronToken}` : undefined;
  }

  try {
    const user = User.fromStorageString(oidcStorage);
    return user.access_token ? `Bearer ${user.access_token}` : undefined;
  } catch {
    return undefined;
  }
}
